import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const FIELD_DECIMAL_PLACES_CONFIG_UPDATED = gql`
  subscription fieldDecimalPlacesConfigUpdated($fieldType: String!) {
    fieldDecimalPlacesConfigUpdated(fieldType: $fieldType) {
      fieldDecimalPlacesConfig {
        fieldType
        decimalPlaces
        maxDecimalPlaces
        displayName
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
